'use strict';

(function () {

  const link = [].slice.call(document.querySelectorAll('a[href^="#"]'));
  const ua  = window.navigator.userAgent.toLowerCase();
  const ms  = ua.indexOf('msie') > -1 || ua.indexOf('trident') > -1 || ua.indexOf('edge') > -1;

  if(ms == true) {

    for (const btn of link) {
      btn.addEventListener('click', (e) => {
        const target = e.target;
        e.preventDefault();
        const targetId = target.hash;
        document.querySelector(targetId).scrollIntoView({
          behavior: 'smooth'
        });
      });
    }

  } else {

    for (const btn of link) {
      btn.addEventListener('click', e => {
        const target = e.target;
        e.preventDefault();
        const targetId = target.hash;
        const targetElement = document.querySelector(targetId);
        const rectTop = targetElement.getBoundingClientRect().top;
        const offsetTop = window.pageYOffset;
        const header = 90;
        const top = rectTop + offsetTop - header;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      });
    }

  }


}());
